import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";

import FormikField from "components/formComponents/FormikField";
import {useFormik} from "formik";
import * as Yup from "yup";
import {passwordValidation} from "../constants/validationSchemas";
import {useTranslation} from "react-i18next";
import {dataEncryption, setLoginCookie} from "../utils/api";
import swal from "sweetalert";
// import jwtDecode from "jwt-decode";
import {authData, setLoadAuth} from "../redux/reducers/auth";
import {useAuthLoginMutation} from "../redux/api/AuthApi";

export default function Login() {
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const [showPsw, setShowPsw] = useState(false);
  const [login] = useAuthLoginMutation()
  const {
    message,
    login: loginEmail,
    password,
  } = useSelector((state) => state.auth);

  const SignInSchema = Yup.object().shape({
    email: Yup.string()
      .max(250, t("validation.notMore", {number: 250}))
      .email(t("validation.incorrectEmail")).required(t("validation.required")),
    password: passwordValidation(t).required(t("validation.required")),
  });

  const onSubmit = ({email, password}) => {
    const encryptedLogin = dataEncryption(email.trim());
    const encryptedPSW = dataEncryption(password.trim());
    dispatch(setLoadAuth({authInProcess: true}));
    login({login: encryptedLogin, password: encryptedPSW})

      .then(({data: auth}) => {
        dispatch(setLoadAuth(authData(null, true)));

        if (auth && auth.status === 403) {
          return swal({
            icon: "warning",
            text: "Your account has been deactivated!"
          })
        }
        if (auth) {
          // const AccessToken = auth.accessToken;
          setLoginCookie(auth);
          window.location.reload()
          // if (AccessToken) {
          //   let data = jwtDecode(AccessToken);
          //   let newState = authData(data, false)
          //   dispatch(setLoadAuth(newState));
          // }
        }
      });
  }

  const formik = useFormik({
    initialValues: {
      email: loginEmail,
      password: password,
    },
    onSubmit,
    validationSchema: SignInSchema,
  });

  return (
    <div
      className="p-4 bg-white rounded shadow"
      style={{
        maxWidth: "500px",
        width: "100%",
        margin: "0 auto",
      }}
    >
      <form onSubmit={formik.handleSubmit}>
        <div className="m-2">
          <div className="d-flex justify-content-center align-items-center admin-logo">
            Administration
            {/*<img height={42} src={getLogoUrl("logo-dark")} alt={"logo"}/>*/}
          </div>
          <div className="position-relative pb-3 mb-3">
            <label className="input-element-label">{t("email")}</label>
            <FormikField name="email" className={``} formik={formik}/>
          </div>
          <div className="position-relative mb-3">
            <label className="input-element-label">{t("password")}</label>
            <div className="position-relative pb-3">
              <FormikField
                name={"password"}
                className={``}
                formik={formik}
                type={showPsw ? "text" : "password"}
              />
              <span
                className={`password-check ${showPsw ? "show" : ""}`}
                onClick={() => setShowPsw(!showPsw)}
              />
            </div>
          </div>

          <div className="text-center mt-4 position-relative pb-1">
            <button type="submit" className="btn btn-primary px-4">
              {t("enter")}
            </button>
            {message && <span className="text-danger"> {message}</span>}
          </div>
        </div>
      </form>
    </div>
  );
}
